export default __webpack_public_path__ + "static/media/7.8c6fa47f.jpg";